import { renderPopupContainer } from "./renderPopupContainer";

/**
 * Bindea popup a un sublayer (lyr) con el mismo contrato que createGeoJsonLayer:
 * popup puede ser:
 * - string
 * - ReactElement
 * - fn(feature, item, api) => string|ReactElement|any
 */
export function bindPopupToLeafletLayer({ lyr, popup, feature, item }) {
    if (!popup || !lyr?.bindPopup) return false;

    const api = {
        close: () => lyr.closePopup?.(),
        open: () => lyr.openPopup?.(),
        layer: lyr,
        feature,
        item,
    };

    const content =
        typeof popup === "function" ? popup(feature, item, api) : popup;

    const container = renderPopupContainer(content);
    lyr.bindPopup(container);
    return true;
}